module.exports = __webpack_public_path__ + "img/icon-android.fa5f752a.png";